import { useEffect, useState } from "react";
import { Chicken } from "../types/Chicken";
import { ChickenItem } from "../components/ChickenItem";
import { ChickenProfileItem } from "../components/ChickenProfileItem";

export const ChickenProfile = ({profile, images, chickens, user_id}: {profile: Chicken, images: object, chickens: Chicken[], user_id: integer}) => {
  return (
    <>
      <div>
        <ChickenProfileItem key={profile.id} image_url={images[profile.attributes.annotation_id]} chicken={profile} user_id={user_id} />
      </div>
      <div className="max-w-7xl mx-auto">
        { chickens && chickens.length ? (<h2 className="text-black font-semibold text-2xl mb-10">Other sightings</h2>) : (<></>) }
        <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          { chickens.map((chicken: Chicken) => (
            <ChickenItem key={chicken.id} image_url={images[chicken.attributes.annotation_id]} chicken={ chicken } annotation_value={ true } user_id={user_id} />
          )) }
        </div>
      </div>
    </>
  );
};
